<content-block [title]="'Preference.Contact.Title' | translate" [headerActions]="contentBlockActions" classList="has-spacer">
    <form [formGroup]="form" *ngIf="form">
        <div style="display: flex">
            <div class="col-md-6 mr-lg has-spacer" style="padding-right: 16px">
                <div class="cell-title">{{ 'Contact.Telephone' | translate }}</div>
                <div class="cell-value">
                    <ng-container *ngIf="!isEditMode; else editPhone">
                        <b>
                            {{
						        form.value.telephone?.internationalNumber || form.value.telephone?.number || form.value.telephone
                            }}
                        </b>
                    </ng-container>
                    <ng-template #editPhone>
                        <app-custom-phone-input
                                [id]="'field-telephone-tiers-front'"
                                formControlName="telephone"
                                [selectedCountryISO]="selectedCountryISO"
                            >
                        </app-custom-phone-input>
                        <form-control-feedback [field]="form?.controls?.telephone"></form-control-feedback>
                    </ng-template>
                </div>
            </div>
            <div class="col-md-6 mr-lg has-spacer" style="padding-left: 16px">
                <div class="cell-title">{{ 'Contact.Email' | translate }}</div>
                <div class="cell-value">
                    <ng-container *ngIf="!isEditMode; else editEmail">
                        <b>{{ form.value.email }}</b>
                    </ng-container>
                    <ng-template #editEmail>
                        <input class="form-control" formControlName="email" />
                        <form-control-feedback [field]="form?.controls?.email"></form-control-feedback>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="edit-btns text-end" *ngIf="isEditMode" style="margin-top: 24px">
            <button type="button"
                    class="btn btn-secondary btn-cancel me-2"
                    (click)="cancel()"
                    [disabled]="preferenceService.editLoading$ | async">
                {{ 'Actions.Cancel' | translate }}
            </button>
            <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="preferenceService.editLoading$ | async">
                <loader-button-spinner [isShowButtonSpinner]="preferenceService.editLoading$ | async"></loader-button-spinner>
                {{ 'Actions.Confirm' | translate }}
            </button>
        </div>
    </form>
    <div class="date-modif" *ngIf="!isEditMode && preferenceContact?.lastDateModification">
        <p>
            {{
				'Preference.DerniereModification'
					| translate
						: {
								dateModification: preferenceContact.lastDateModification | date: 'dd/MM/yyyy',
								heureModification: preferenceContact.lastDateModification | date: 'HH',
								minuteModification: preferenceContact.lastDateModification | date: 'mm',
								utilisateurModification: preferenceContact.lastUtilisateurModification
						  }
            }}
        </p>
    </div>
</content-block>

<ng-template #contentBlockActions>
    <button type="button" class="btn btn-primary" (click)="edit()" *ngIf="allowEdit && !isEditMode" [disabled]="anyEditMode$ | async">
        <span>
            <i class="far fa-pencil"></i>
            <loader-button-spinner [isShowButtonSpinner]="preferenceService.getLoading$ | async"></loader-button-spinner>
            {{ 'Actions.Edit' | translate }}
        </span>
    </button>
</ng-template>
